﻿$.fn.dxCtrlPageSms = function custom_dxCtrlPageSms(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlpagesms dx-ctrl");
        this.createInstance(new cdxCtrlPageSms(this, option));
    }
    return this;
}

window.cdxCtrlPageSms = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }
    if (typeof option.context_grid == 'undefined') option.context_grid = "grid_sms"

    var dxCtrlGridArticle = null
    var ctrlResize = null;
    function mConstruit() {
        container.empty()
        ctrlResize = $("<div style='width:100%;height:100%;'/>").appendTo(container).dxCtrlSplitterResize2({
            bddCtrl: option.bddCtrl,
            context_grid: option.context_grid,
            withMarge: true,
            widthLeftInitial: 300
        }).dxCtrlSplitterResize2("instance")
        ctrlResize.mConstruitRight(function (contentElement) {
            contentElement.css("position", "relative")
            contentElement.css("box-sizing", "border-box")
            //dxCtrlGridCpt = option.bddCtrl.getObjet("doc_cpt").contentTemplateGrid(contentElement, {});
        })
        ctrlResize.mConstruitLeft(function (contentElement) {
            mConstruitMenu(contentElement)
        })
    }

    var dxTreeView = null
    var $DivLoad = null
    function mConstruitMenu(contentElement) {
        //contentElement.css({
        //    "border-right": theme.border,
        //    "background-color": theme.backgroundcolorTooltip.replace("rgb(", "rgba(").replace(")", ", 0.2)")
        //})

        var $DivTreeView = $("<div/>").appendTo(contentElement)
        var $DivBt = $("<div style='padding:5px;'/>").appendTo(contentElement)

        var ds = []

        ds.push({
            id: "1",
            icon: "fas fa-comment-sms",
            text: "Sms",
            items: [{
                id: "1_7",
                icon: "fas fa-comment-sms",
                icon2: "fas fa-pen",
                text: "Brouillons"
            }, {
                id: "1_9",
                icon: "fas fa-comment-sms",
                icon2: "fas fa-spinner fa-spin-pulse",
                text: "En cours d'envoi"
            }, {
                id: "1_10",
                icon: "fas fa-comment-sms",
                icon2: "fas fa-paper-plane",
                text: "Envoyés"
            }, {
                id: "1_12",
                icon: "fas fa-comment-sms",
                icon2: "fas fa-bullseye",
                text: "Envoyés en tracking"
            }, {
                id: "1_13",
                icon: "fas fa-user-secret",
                text: "Téléphone désinscrit"
            }, {
                id: "1_14",
                icon: "fas fa-ghost",
                text: "Téléphone en bounce"
            }]
        })
        if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid] = { dsmenu: ds }
        if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].dsmenu == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid].dsmenu = ds
        if (!mDsIsEgale(ds, option.bddCtrl.utiCourantParaJson[option.context_grid].dsmenu)) option.bddCtrl.utiCourantParaJson[option.context_grid].dsmenu = ds
        lst = []
        ds.forEach(function (item) {
            lst.push(item)
            lst = lst.concat(mGetLstItemTreeview(item))
        })
        lst.forEach(function (item) { mInitFromSaveTreeview(item, option.bddCtrl.utiCourantParaJson[option.context_grid].dsmenu, null, "id") })

        dxTreeView = $("<div style='height:100%;'/>").appendTo($DivTreeView).dxTreeView({
            dataSource: option.bddCtrl.utiCourantParaJson[option.context_grid].dsmenu,
            width: "100%",
            height: "100%",
            focusStateEnabled: true,
            selectionMode: "single",
            //showCheckBoxesMode: true,
            onItemClick: function (e) {
                dxTreeView.selectItem(e.itemData)
            },
            onItemSelectionChanged: function (e) {
                e.component.element().find(".dx-treeview-item").css("background-color", "");
                $(e.itemElement).css("background-color", theme.backgroundcolorAccentSelect);
                Me.mSelect(((e.component.getSelectedNodes().length == 0) ? null : e.component.getSelectedNodes()[0].itemData))
                option.bddCtrl.utiCourantParaJson[option.context_grid].dsmenu = e.component.option("dataSource")
                option.bddCtrl.mSaveParaJsonUtilisateur();
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                var $Table = $("<table/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px;font-size:160%;padding-right:5px;'/>").appendTo($Tr)
                var $Icone = $("<i class='" + itemData.icon + "' style='position:relative;'></i>").appendTo($Td);
                if (typeof itemData.icon2 != 'undefined') {
                    var $Icone2 = $("<i class='" + itemData.icon2 + "' style='position:absolute;bottom:-1px;right:-1px;color:" + theme.backgroundcolorAccent + ";font-size:70%;'></i>").appendTo($Icone);
                    if (typeof itemData.color2 != 'undefined') $Icone2.css("color", itemData.color2)
                }
                $Icone.appendTo($Td)
                var $Td = $("<td style='width:100%;white-space:nowrap;'>" + itemData.text + "</td>").appendTo($Tr)
            },
            onContentReady: function (e) {
                $(e.component.element().find(".dx-state-selected").children()[0]).css("background-color", theme.backgroundcolorAccentSelect);
                Me.mSelect(((e.component.getSelectedNodes().length == 0) ? null : e.component.getSelectedNodes()[0].itemData))
            }
        }).dxTreeView('instance');

        ////$DivLoad = $("<div/>").appendTo(contentElement)
        ////resizeObserver.mAdd($DivLoad, function () {
        ////    $DivTreeView.css("height", "calc(100% - " + ($DivLoad.innerHeight() + $DivBt.innerHeight()) + "px)")
        ////})
        ////mRempliLoadEnCours()

        ////function mRempliLoadEnCours() {
        ////    $("<div/>").appendTo($DivLoad).dxCtrlSuiviTraitementEmailServeur({
        ////        bddCtrl: option.bddCtrl,
        ////        email_recu: false,
        ////        email_envoi: false,
        ////        sms_envoi: true
        ////    })
        ////}
        $DivLoad = $("<div style='position:absolute;bottom:0;width:100%;'/>").appendTo(container)
        resizeObserver.mAdd($DivLoad, function () {
            dxScroll.element().css("height", "calc(100% - " + $DivLoad.innerHeight() + "px)")
        })

        //$(document).on('sendedSmsEvent', function (e, eventInfo) {
        //    mRempliLoadEnCours()
        //});
        //mRempliLoadEnCours()
    }

    //var lstCtrlSmsEnCours = []
    //function mRempliLoadEnCours() {
    //    //var sql = "select id_com_sms_envoi from com_sms_envoi WITH (NOLOCK) INNER JOIN (select id_com,count(*) as nb from com_destinataire where id_table_com=" + option.bddCtrl.getObjet("com_sms_envoi").mGetTable().id_table + " group by id_com) as com_destinataire ON com_sms_envoi.id_com_sms_envoi=com_destinataire.id_com where com_sms_envoi.id_utilisateur=" + option.bddCtrl.utiCourant.id_utilisateur + " and com_sms_envoi.date_envoi>'" + (new Date(parametre.dateNow)).addDays(-60).toFrenchDateTime() + "' And id_historique_sup Is null and NOT id_type_classement in (10,12) and com_destinataire.nb>=" + parametre.nbre_destinataire_sms_max
    //    option.bddCtrl.mAjaxCall({
    //        command: "getdataslstsmsemailencours",
    //        idtablecom: option.bddCtrl.getObjet("com_sms_envoi").mGetTable().id_table,
    //        nbsmsmax: parametre.nbre_destinataire_sms_max,
    //        type: "sms"
    //    }, function (data) {
    //        data.emailsms = JSON.parse(data.emailsms)
    //        //if (typeof data.emailsms == 'undefined') data.emailsms = []
    //        data.emailsms.forEach(function (itemData) {
    //            if (lstCtrlSmsEnCours.filter(function (ctrl) { return ctrl.option("id") == itemData.id_com_sms_envoi }).length == 0) {
    //                var newCtrl = $("<div style='padding:5px;box-sizing:border-box;'/>").appendTo($DivLoad).dxCtrlChartTitleEnvoi({
    //                    bddCtrl: option.bddCtrl,
    //                    data: option.bddCtrl.getObjet("com_sms_envoi", itemData.id_com_sms_envoi).data,
    //                    reduit: true,
    //                    removeOnEnd: true,
    //                    onClick: function () { option.bddCtrl.getObjet("com_sms_envoi", itemData.id_com_sms_envoi).mShowPopup() }
    //                }).dxCtrlChartTitleEnvoi("instance")
    //                newCtrl.mStartUpdate()
    //                lstCtrlSmsEnCours.push(newCtrl)
    //            }
    //        })
    //    })
    //}

    this.mSelect = function (itemData) {
        if (!itemData) { ctrlResize.mConstruitRight(function (contentElement) { contentElement.empty() }) }
        else {
            var $Icone = $("<i class='" + itemData.icon + "' style='position:relative;'></i>");
            if (typeof itemData.icon2 != 'undefined') {
                var $Icone2 = $("<i class='" + itemData.icon2 + "' style='position:absolute;bottom:-1px;right:-1px;color:" + theme.backgroundcolorAccent + ";font-size:70%;'></i>").appendTo($Icone);
                if (typeof itemData.color2 != 'undefined') $Icone2.css("color", itemData.color2)
            }
            var opt = {
                bddCtrl: option.bddCtrl,
                context_grid: option.context_grid,
                eleIcon: $Icone,
                lstIdTypeDoc: [],
                lstIdTypeStatut: [],
                optionFilter: {}
            }
            if (itemData.id.contains("_")) {
                opt.lstIdTypeClassement.push(itemData.id.split("_")[1])
            } else { opt.lstIdTypeClassement = [] }

            ctrlResize.mConstruitRight(function (contentElement) {
                contentElement.css("padding", "0px")
            })
        }
    }

    this.element = function () { return container }

    mConstruit();
}